import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TelegramApp from './TelegramApp';
import ThemeProviderWrapper from './Components/Theme/ThemeProviderWrapper';

/**
 * Wrapper for TelegramApp, which handles routing and theme
 */
const TelegramAppWrapper = () => {
  return (
    <ThemeProviderWrapper>
      <Routes>
        <Route path="/telegram-react" element={<TelegramApp />} />
        <Route path="/" element={<TelegramApp />} />
      </Routes>
    </ThemeProviderWrapper>
  );
};

export default TelegramAppWrapper;
